// Searchable Dropdown Functionality - Combobox Style (if not already loaded)
if (!window.makeSelectSearchable) {
  (function() {
    // Add CSS for searchable dropdowns
    const style = document.createElement('style');
    style.textContent = `
      .searchable-select-wrapper {
        position: relative;
        width: 100%;
      }
      .searchable-select-wrapper > select {
        position: absolute !important;
        opacity: 0 !important;
        pointer-events: none !important;
        height: 0 !important;
        width: 0 !important;
      }
      .searchable-select-input {
        width: 100%;
        padding: 10px 30px 10px 12px;
        font-size: 14px;
        height: 44px;
        border: 1px solid #ddd;
        border-radius: 3px;
        background: #fff url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>") no-repeat;
        background-position: calc(100% - 10px) center;
        cursor: pointer;
        box-sizing: border-box;
        outline: none;
      }
      .searchable-select-input:focus {
        border-color: #999;
      }
      .searchable-select-input.disabled {
        background-color: #f5f5f5;
        color: #999;
        cursor: not-allowed;
      }
      .searchable-select-input::placeholder {
        color: #999;
      }
      .searchable-select-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #ddd;
        border-top: none;
        border-radius: 0 0 3px 3px;
        max-height: 250px;
        overflow-y: auto;
        z-index: 9999;
        display: none;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      .searchable-select-dropdown.open {
        display: block;
      }
      .searchable-select-option {
        padding: 10px 15px;
        cursor: pointer;
        font-size: 14px;
      }
      .searchable-select-option:hover,
      .searchable-select-option.highlighted {
        background: #f0f0f0;
      }
      .searchable-select-option.selected {
        background: #e8f4fc;
        font-weight: 500;
      }
      .searchable-select-no-results {
        padding: 10px 15px;
        color: #999;
        font-size: 14px;
      }
      .fitment-add-equipment-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        text-transform: uppercase;
        padding: 6px 14px;
        border: 1px solid #F7B910;
        background: #F7B910;
        color: #000;
        cursor: pointer;
        height: 36px;
        line-height: 20px;
        min-width: 130px;
        text-align: center;
        transition: all 0.2s ease;
        font-weight: 600;
      }
      .fitment-add-equipment-btn:hover {
        background: #d9a00e;
        border-color: #d9a00e;
      }
      .fitment-add-equipment-btn svg {
        flex-shrink: 0;
      }
      @media (max-width: 480px) {
        .fitment-add-equipment-btn {
          width: 100%;
          justify-content: center;
          margin-top: 8px;
        }
      }
    `;
    document.head.appendChild(style);

    // Function to make a select searchable
    window.makeSelectSearchable = function(select) {
      if (!select || select.dataset.searchable === 'true') return;
      select.dataset.searchable = 'true';

      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'searchable-select-wrapper';
      select.parentNode.insertBefore(wrapper, select);
      wrapper.appendChild(select);

      // Get placeholder text
      const placeholder = select.options[0]?.text || 'Select...';

      // Create input element (replaces display)
      const input = document.createElement('input');
      input.type = 'text';
      input.className = 'searchable-select-input';
      input.placeholder = placeholder;
      input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
      if (select.disabled) {
        input.classList.add('disabled');
        input.disabled = true;
      }
      wrapper.appendChild(input);

      // Create dropdown
      const dropdown = document.createElement('div');
      dropdown.className = 'searchable-select-dropdown';
      wrapper.appendChild(dropdown);

      let isOpen = false;
      let openedOnFocus = false; // suppress the click that fires right after a focus-open
      let highlightedIndex = -1;
      let userCleared = false; // Track if user cleared the field

      // Render options
      function renderOptions(filter = '') {
        const filterLower = filter.toLowerCase();
        let html = '';
        let hasResults = false;
        let firstMatchIndex = -1;
        
        for (let i = 0; i < select.options.length; i++) {
          const opt = select.options[i];
          if (opt.value === '' && i === 0) continue; // Skip placeholder
          
          const text = decodeHtmlEntities(opt.text);
          if (filterLower && !text.toLowerCase().includes(filterLower)) continue;
          
          if (firstMatchIndex === -1) firstMatchIndex = i;
          hasResults = true;
          const selectedClass = opt.selected ? 'selected' : '';
          const highlightedClass = i === highlightedIndex ? 'highlighted' : '';
          html += `<div class="searchable-select-option ${selectedClass} ${highlightedClass}" data-value="${opt.value}" data-index="${i}">${text}</div>`;
        }
        
        if (!hasResults) {
          html = '<div class="searchable-select-no-results">No results found</div>';
        }
        
        dropdown.innerHTML = html;
        return firstMatchIndex;
      }

      // Open dropdown
      function openDropdown() {
        if (select.disabled) return;
        isOpen = true;
        dropdown.classList.add('open');
        // Always show all options when opening
        renderOptions('');
        input.select(); // Select all text for easy replacement
      }

      // Close dropdown
      function closeDropdown(restoreValue = true) {
        isOpen = false;
        openedOnFocus = false;
        dropdown.classList.remove('open');
        highlightedIndex = -1;
        if (restoreValue) {
          if (input.value.trim() === '') {
            // Field left empty: commit the clear so the select + downstream cascade update
            // and it can't be resurrected from the stale select value.
            if (select.value !== '') {
              select.value = '';
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            // Snap the text back to the actual selected option's label.
            input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
          }
        }
        userCleared = false;
      }

      // Select option
      function selectOption(index) {
        select.selectedIndex = index;
        input.value = decodeHtmlEntities(select.options[index]?.text) || '';
        userCleared = false;
        closeDropdown(false);
        
        // Trigger change event
        const event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);
      }

      // Update input when select changes externally
      function updateFromSelect() {
        // Don't resurrect a field the user just cleared (the select may still hold the old value).
        if (!userCleared) {
          input.value = select.selectedIndex > 0 ? decodeHtmlEntities(select.options[select.selectedIndex].text) : '';
        }
        input.placeholder = select.options[0]?.text || 'Select...';
        if (select.disabled) {
          input.classList.add('disabled');
          input.disabled = true;
        } else {
          input.classList.remove('disabled');
          input.disabled = false;
        }
      }

      // Event listeners
      input.addEventListener('focus', () => {
        userCleared = false;
        openedOnFocus = true;
        openDropdown();
      });

      input.addEventListener('click', () => {
        // The click that fires immediately after a focus-open must not toggle it closed
        if (openedOnFocus) {
          openedOnFocus = false;
          return;
        }
        // Tapping the field toggles the dropdown (fixes mobile: tap again to close)
        userCleared = false;
        if (isOpen) {
          closeDropdown();
          input.blur();
        } else {
          openDropdown();
        }
      });

      input.addEventListener('input', (e) => {
        if (!isOpen) openDropdown();
        highlightedIndex = -1;
        // If field is empty, user cleared it
        if (e.target.value === '') {
          userCleared = true;
        }
        renderOptions(e.target.value);
      });

      input.addEventListener('keydown', (e) => {
        // Handle backspace/delete - if field becomes empty, mark as cleared
        if ((e.key === 'Backspace' || e.key === 'Delete')) {
          setTimeout(() => {
            if (input.value === '') {
              userCleared = true;
              renderOptions('');
            }
          }, 0);
        }
        if (e.key === 'Escape') {
          closeDropdown();
          input.blur();
        }
        if (e.key === 'Enter') {
          e.preventDefault();
          const options = dropdown.querySelectorAll('.searchable-select-option');
          if (highlightedIndex >= 0 && options[highlightedIndex]) {
            selectOption(parseInt(options[highlightedIndex].dataset.index));
          } else if (options.length > 0) {
            selectOption(parseInt(options[0].dataset.index));
          }
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const options = dropdown.querySelectorAll('.searchable-select-option');
          if (options.length > 0) {
            highlightedIndex = Math.min(highlightedIndex + 1, options.length - 1);
            options.forEach((opt, i) => opt.classList.toggle('highlighted', i === highlightedIndex));
            options[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
          }
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          const options = dropdown.querySelectorAll('.searchable-select-option');
          if (options.length > 0) {
            highlightedIndex = Math.max(highlightedIndex - 1, 0);
            options.forEach((opt, i) => opt.classList.toggle('highlighted', i === highlightedIndex));
            options[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
          }
        }
      });

      dropdown.addEventListener('mousedown', (e) => {
        e.preventDefault(); // Prevent input blur
        const option = e.target.closest('.searchable-select-option');
        if (option) {
          selectOption(parseInt(option.dataset.index));
        }
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target)) {
          closeDropdown();
        }
      });

      // Observe select for changes (disabled state, options)
      const observer = new MutationObserver(() => {
        updateFromSelect();
      });
      observer.observe(select, { attributes: true, childList: true, subtree: true });

      // Store reference for updates
      select._searchableUpdate = updateFromSelect;

      return wrapper;
    };

    // Make all selects in a container searchable
    window.makeSelectsSearchable = function(container) {
      const selects = container.querySelectorAll('select');
      selects.forEach(select => window.makeSelectSearchable(select));
    };
  })();
}

// Decode HTML entities (e.g. "AR1K11001 &amp; Above" -> "AR1K11001 & Above"). Regex-based, no DOM.
function decodeHtmlEntities(str) {
  str = String(str == null ? "" : str);
  if (str.indexOf("&") === -1) return str;
  return str
    .replace(/&lt;/gi, "<").replace(/&gt;/gi, ">").replace(/&quot;/gi, '"')
    .replace(/&#0*39;|&apos;/gi, "'").replace(/&nbsp;/gi, " ")
    .replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(+n); })
    .replace(/&#x([0-9a-f]+);/gi, function (_, n) { return String.fromCharCode(parseInt(n, 16)); })
    .replace(/&amp;/gi, "&");
}

class FitmentSidebar extends HTMLElement {
  constructor() {
    super();
    this.heavyDutyData = this.loadHeavyDutyData();
    this.truckData = this.loadTruckData();
    this.automotiveData = this.loadAutomotiveData();
    this.state = this.loadStateFromUrl() || {
      category: "Heavy-Duty Machinery", make: "", type: "", submodel: "", model: "", variant: "", variant2: "",
      year: "", autoMake: "", autoModel: "", trim: "", engine: ""
    };
  }

  connectedCallback() { 
    this.render(); 
    this.cacheEls(); 
    this.bindEvents(); 
    this.prefillFromState(); 
    // prefill above ran against empty dropdowns and may have wiped the state; restore it from the
    // URL so the "You are now searching parts for…" breadcrumb shows instantly, before the CSV loads.
    const urlState = this.loadStateFromUrl();
    if (urlState) this.state = urlState;
    this.updateBanner();
    this.initSearchableDropdowns();
    this.loadCsvData();
  }
  
  initSearchableDropdowns() {
    // Initialize searchable dropdowns if function is available
    if (window.makeSelectSearchable) {
      setTimeout(() => {
        window.makeSelectSearchable(this.categorySelect);
        window.makeSelectSearchable(this.makeSelect);
        window.makeSelectSearchable(this.typeSelect);
        window.makeSelectSearchable(this.submodelSelect);
        window.makeSelectSearchable(this.modelSelect);
        window.makeSelectSearchable(this.variantSelect);
        window.makeSelectSearchable(this.variant2Select);
        window.makeSelectSearchable(this.yearSelect);
        window.makeSelectSearchable(this.autoMakeSelect);
        window.makeSelectSearchable(this.autoModelSelect);
        window.makeSelectSearchable(this.trimSelect);
        window.makeSelectSearchable(this.engineSelect);
      }, 100);
    }
  }

  loadHeavyDutyData() {
    const scripts = document.querySelectorAll('.product-compatability-matrix');
    const entries = [];
    scripts.forEach(script => {
      const raw = script.textContent.trim();
      if (!raw) return;
      raw.split('\n').forEach(line => {
        const fields = line.split('|').map(s => s.trim());
        if (fields.length >= 4) entries.push({ make: fields[0], type: fields[1], submodel: fields[2] || "", model: fields[3], variant: fields[4] || "", variant2: fields[5] || "" });
      });
    });
    return entries;
  }

  loadTruckData() {
    const scripts = document.querySelectorAll('.product-compatability-matrix2');
    const entries = [];
    scripts.forEach(script => {
      const raw = script.textContent.trim();
      if (!raw) return;
      raw.split('\n').forEach(line => {
        const fields = line.split('|').map(s => s.trim());
        if (fields.length >= 3) entries.push({ year: fields[0] || "", make: fields[1] || "", model: fields[2] || "", trim: fields[3] || "", engine: fields[4] || "" });
      });
    });
    return entries;
  }

  loadAutomotiveData() {
    const scripts = document.querySelectorAll('.product-compatability-matrix3');
    const entries = [];
    scripts.forEach(script => {
      const raw = script.textContent.trim();
      if (!raw) return;
      raw.split('\n').forEach(line => {
        const fields = line.split('|').map(s => s.trim());
        if (fields.length >= 3) entries.push({ year: fields[0] || "", make: fields[1] || "", model: fields[2] || "", trim: fields[3] || "", engine: fields[4] || "" });
      });
    });
    return entries;
  }

  // ---- CSV (both-sources) loading, mirroring the homepage filter ----
  loadCsvData() {
    const FITMENT_URL = 'https://unrivaled-zuccutto-bdbd4b.netlify.app/.netlify/functions/fitment';
    // Cache the machine dropdown data (make/type/model lists) so it isn't refetched every load.
    const DKEY = 'ufFitmentDropdown_v1', DTTL = 15 * 60 * 1000;
    const loadDropdown = () => {
      try {
        const c = sessionStorage.getItem(DKEY);
        const ts = parseInt(sessionStorage.getItem(DKEY + '_ts') || '0', 10);
        if (c && (Date.now() - ts) < DTTL) { const d = JSON.parse(c); if (d) return Promise.resolve(d); }
      } catch (e) {}
      return fetch(FITMENT_URL, { headers: { 'Accept': 'application/json' } })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(d => {
          try { sessionStorage.setItem(DKEY, JSON.stringify(d)); sessionStorage.setItem(DKEY + '_ts', String(Date.now())); } catch (e) {}
          return d;
        });
    };
    Promise.all([
      this.loadLiveSkus(),
      loadDropdown()
    ])
      .then(([liveSkus, data]) => {
        this.mergeCsvData(data, liveSkus);
        // The machine data has now loaded from the CSV. If the URL specified a
        // machine, re-apply it now that the dropdowns have options — otherwise
        // prefill ran earlier against empty dropdowns and wiped the state back to
        // "No vehicle selected yet."
        const urlState = this.loadStateFromUrl();
        if (urlState) {
          this.state = urlState;
          this.prefillFromState();
          this.updateBanner();
        } else if (!this.state.make && !this.state.year) {
          if (this.state.category === 'Heavy-Duty Machinery' || !this.state.category) this.populateMakes();
          else this.populateYears();
        }
      })
      .catch(err => { console.error('Fitment CSV merge (sidebar) failed:', err); });
  }

  loadLiveSkus() {
    // The set of live product SKUs (used to hide CSV machines that have no live product).
    // Cache it: crawling /products.json across ~12 pages on every load is a big part of the lag.
    // IMPORTANT: only cache a COMPLETE crawl. If any page fails after retries, fail open (return an
    // empty set so ALL makes show) rather than caching a partial set that would hide valid machines.
    const KEY = 'ufLiveSkus_v2', TTL = 15 * 60 * 1000;
    try {
      const c = sessionStorage.getItem(KEY);
      const ts = parseInt(sessionStorage.getItem(KEY + '_ts') || '0', 10);
      if (c && (Date.now() - ts) < TTL) { const arr = JSON.parse(c); if (arr && arr.length) return Promise.resolve(new Set(arr)); }
    } catch (e) {}
    const set = new Set();
    const wait = ms => new Promise(r => setTimeout(r, ms));
    const getPage = (page, attempt = 0) => fetch('/products.json?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } })
      .then(r => { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .catch(() => attempt < 3 ? wait(300 * (attempt + 1)).then(() => getPage(page, attempt + 1)) : { _failed: true });
    let failed = false;
    const loop = (page) => getPage(page).then(d => {
      if (d && d._failed) { failed = true; return; }
      const list = (d && d.products) || [];
      list.forEach(p => (p.variants || []).forEach(v => { const t = (v.sku || '').trim().toLowerCase(); if (t) set.add(t); }));
      if (list.length === 250 && page < 40) return loop(page + 1);
    });
    return loop(1).then(() => {
      if (failed) return new Set(); // incomplete crawl -> show all makes, don't cache
      try { sessionStorage.setItem(KEY, JSON.stringify([...set])); sessionStorage.setItem(KEY + '_ts', String(Date.now())); } catch (e) {}
      return set;
    });
  }

  mergeCsvData(data, liveSkus) {
    const live = liveSkus || new Set();
    const filterByLive = live.size > 0;
    if (!filterByLive) console.warn('[fitment sidebar] Live SKU list empty — showing all CSV machines.');
    const isLive = e => !filterByLive || (Array.isArray(e.skus) && e.skus.some(s => live.has(String(s).trim().toLowerCase())));
    const mergeInto = (arr, rows, keyFn) => {
      const seen = new Set(arr.map(keyFn));
      rows.forEach(row => { const k = keyFn(row); if (!seen.has(k)) { seen.add(k); arr.push(row); } });
    };
    mergeInto(
      this.heavyDutyData,
      (data.heavyDuty || []).filter(isLive).map(e => ({
        make: e.make || '', type: e.type || '', submodel: e.submodel || '',
        model: e.model || '', variant: e.variant || '', variant2: e.variant2 || ''
      })),
      e => [e.make, e.type, e.submodel, e.model, e.variant, e.variant2].join('||')
    );
    mergeInto(
      this.automotiveData,
      (data.automotive || []).filter(isLive).map(e => ({
        year: e.year || '', make: e.make || '', model: e.model || '', trim: e.trim || '', engine: e.engine || ''
      })),
      e => [e.year, e.make, e.model, e.trim, e.engine].join('||')
    );
  }

  getVehicleData() {
    if (this.state.category === 'Trucks') return this.truckData;
    if (this.state.category === 'Automotive') return this.automotiveData;
    return [];
  }

  loadStateFromUrl() {
    const p = new URLSearchParams(window.location.search);
    const category = p.get("category") || "", make = p.get("make") || "", type = p.get("type") || "";
    const submodel = p.get("submodel") || "", model = p.get("model") || "", variant = p.get("variant") || "";
    const variant2 = p.get("variant2") || "";
    const year = p.get("year") || "", trim = p.get("trim") || "", engine = p.get("engine") || "";
    let detectedCategory = category || (year ? "Automotive" : (type || make) ? "Heavy-Duty Machinery" : "");
    if (detectedCategory || make || type || model || variant || variant2 || year || trim || engine) {
      return { category: detectedCategory || "Heavy-Duty Machinery", make, type, submodel, model, variant, variant2, year, autoMake: make, autoModel: model, trim, engine };
    }
    return null;
  }

  unique(list) { return [...new Set(list.filter(v => v && v !== ""))]; }
  resetSelect(select, label, disable = true) { if (!select) return; select.innerHTML = `<option value="">${label}</option>`; select.disabled = disable; }

  render() {
    this.innerHTML = `
      <div class="fitment-sidebar">
        <div class="fitment-selected">
          <div class="fitment-selected-title">You are now searching parts for:</div>
          <div class="fitment-selected-vehicle js-fitment-selected-vehicle"></div>
          <button type="button" class="fitment-change-btn js-fitment-change-btn">Choose Machine</button>
          <button type="button" class="fitment-clear-btn js-fitment-clear-btn" style="display:none;">Clear</button>
          <button type="button" class="fitment-add-equipment-btn js-fitment-add-equipment-btn" style="display:none;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg> Add to My Equipment</button>
        </div>
        <div class="fitment-modal-backdrop js-fitment-modal" style="display:none;">
          <div class="fitment-modal">
            <div class="fitment-modal-header"><h4>Select your machine</h4><button type="button" class="fitment-modal-close js-fitment-modal-close">×</button></div>
            <div class="fitment-modal-body">
              <div class="fitment-field"><label>Category</label><select class="js-fitment-category"><option value="Heavy-Duty Machinery">Heavy-Duty Machinery</option><option value="Automotive">Automotive</option><option value="Trucks">Trucks</option></select></div>
              <div class="js-heavy-duty-fields">
                <div class="fitment-field"><label>Make</label><select class="js-fitment-make"><option value="">Make</option></select></div>
                <div class="fitment-field"><label>Type</label><select class="js-fitment-type" disabled><option value="">Type</option></select></div>
                <div class="fitment-field js-submodel-field" style="display:none;"><label>Sub-Model</label><select class="js-fitment-submodel" disabled><option value="">Sub-Model</option></select></div>
                <div class="fitment-field"><label>Model</label><select class="js-fitment-model" disabled><option value="">Model</option></select></div>
                <div class="fitment-field"><label>Variant</label><select class="js-fitment-variant" disabled><option value="">Variant</option></select></div>
                <div class="fitment-field js-variant-2-field" style="display:none;"><label>Variant 2</label><select class="js-fitment-variant-2" disabled><option value="">Variant 2</option></select></div>
              </div>
              <div class="js-automotive-fields" style="display:none;">
                <div class="fitment-field"><label>Year</label><select class="js-fitment-year"><option value="">Year</option></select></div>
                <div class="fitment-field"><label>Make</label><select class="js-fitment-auto-make" disabled><option value="">Make</option></select></div>
                <div class="fitment-field"><label>Model</label><select class="js-fitment-auto-model" disabled><option value="">Model</option></select></div>
                <div class="fitment-field"><label>Trim</label><select class="js-fitment-trim" disabled><option value="">Trim</option></select></div>
                <div class="fitment-field"><label>Engine</label><select class="js-fitment-engine" disabled><option value="">Engine</option></select></div>
              </div>
            </div>
            <div class="fitment-modal-footer"><button type="button" class="fitment-apply-btn js-fitment-apply-btn">Apply & view parts</button></div>
          </div>
        </div>
      </div>`;
  }
  

  cacheEls() {
    this.bannerEl = this.querySelector(".js-fitment-selected-vehicle");
    this.changeBtn = this.querySelector(".js-fitment-change-btn");
    this.clearBtn = this.querySelector(".js-fitment-clear-btn");
    this.addEquipmentBtn = this.querySelector(".js-fitment-add-equipment-btn");
    this.modal = this.querySelector(".js-fitment-modal");
    this.modalClose = this.querySelector(".js-fitment-modal-close");
    this.categorySelect = this.querySelector(".js-fitment-category");
    this.heavyDutyFields = this.querySelector(".js-heavy-duty-fields");
    this.makeSelect = this.querySelector(".js-fitment-make");
    this.typeSelect = this.querySelector(".js-fitment-type");
    this.submodelField = this.querySelector(".js-submodel-field");
    this.submodelSelect = this.querySelector(".js-fitment-submodel");
    this.modelSelect = this.querySelector(".js-fitment-model");
    this.variantSelect = this.querySelector(".js-fitment-variant");
    this.variant2Field = this.querySelector(".js-variant-2-field");
    this.variant2Select = this.querySelector(".js-fitment-variant-2");
    this.automotiveFields = this.querySelector(".js-automotive-fields");
    this.yearSelect = this.querySelector(".js-fitment-year");
    this.autoMakeSelect = this.querySelector(".js-fitment-auto-make");
    this.autoModelSelect = this.querySelector(".js-fitment-auto-model");
    this.trimSelect = this.querySelector(".js-fitment-trim");
    this.engineSelect = this.querySelector(".js-fitment-engine");
    this.applyBtn = this.querySelector(".js-fitment-apply-btn");
  }

  bindEvents() {
    this.changeBtn.addEventListener("click", () => this.openModal());
    this.clearBtn.addEventListener("click", () => this.clearSelection());
    if (this.addEquipmentBtn) this.addEquipmentBtn.addEventListener("click", () => this.openAddEquipmentModal());
    this.modalClose.addEventListener("click", () => this.closeModal());
    // Close on backdrop click ONLY when the press both starts and ends on the backdrop. A searchable
    // dropdown can overflow past the modal box; selecting such an option (on mousedown) closes the
    // dropdown, so the following click lands on the now-exposed backdrop — without this guard that would
    // wrongly dismiss the whole modal.
    let modalPressTarget = null;
    this.modal.addEventListener("mousedown", e => { modalPressTarget = e.target; });
    this.modal.addEventListener("click", e => {
      if (e.target === this.modal && modalPressTarget === this.modal) this.closeModal();
      modalPressTarget = null;
    });
    this.categorySelect.addEventListener("change", () => this.onCategory());
    this.makeSelect.addEventListener("change", () => this.onMake());
    this.typeSelect.addEventListener("change", () => this.onType());
    this.submodelSelect.addEventListener("change", () => this.onSubmodel());
    this.modelSelect.addEventListener("change", () => this.onModel());
    this.variantSelect.addEventListener("change", () => this.onVariant());
    this.variant2Select.addEventListener("change", () => this.onVariant2());
    this.yearSelect.addEventListener("change", () => this.onYear());
    this.autoMakeSelect.addEventListener("change", () => this.onAutoMake());
    this.autoModelSelect.addEventListener("change", () => this.onAutoModel());
    this.trimSelect.addEventListener("change", () => this.onTrim());
    this.engineSelect.addEventListener("change", () => this.onEngine());
    this.applyBtn.addEventListener("click", () => this.applySelection());
  }

  updateBanner() {
    const { category, make, type, submodel, model, variant, variant2, year, autoMake, autoModel, trim, engine } = this.state;
    let parts = [];
    if (category === 'Heavy-Duty Machinery' || (!category && (make || type || model))) parts = [make, type, submodel, model, variant, variant2].filter(Boolean);
    else if (category === 'Automotive' || category === 'Trucks' || year) parts = [year, autoMake, autoModel, trim, engine].filter(Boolean);
    this.bannerEl.textContent = parts.length ? parts.map(v => decodeHtmlEntities(v)).join(" → ") : "No vehicle selected yet.";
    this.clearBtn.style.display = parts.length > 0 ? "inline-block" : "none";
    // Show Add Equipment button only when filter is active and customer is logged in
    if (this.addEquipmentBtn) {
      const isLoggedIn = window.customerLoggedIn || (typeof Shopify !== 'undefined' && Shopify.customer);
      this.addEquipmentBtn.style.display = (parts.length > 0 && isLoggedIn) ? "inline-flex" : "none";
    }
  }

  openModal() { this.modal.style.display = "flex"; this.prefillFromState(); }
  closeModal() { this.modal.style.display = "none"; }

  onCategory() {
    this.state.category = this.categorySelect.value || "Heavy-Duty Machinery";
    this.resetHeavyDutyState(); this.resetAutomotiveState();
    if (this.state.category === 'Heavy-Duty Machinery') { this.heavyDutyFields.style.display = 'block'; this.automotiveFields.style.display = 'none'; this.populateMakes(); }
    else { this.heavyDutyFields.style.display = 'none'; this.automotiveFields.style.display = 'block'; this.populateYears(); }
  }

  resetHeavyDutyState() {
    this.state.make = ""; this.state.type = ""; this.state.submodel = ""; this.state.model = ""; this.state.variant = ""; this.state.variant2 = "";
    this.resetSelect(this.makeSelect, "Make", false); this.resetSelect(this.typeSelect, "Type");
    this.resetSelect(this.submodelSelect, "Sub-Model"); this.resetSelect(this.modelSelect, "Model"); this.resetSelect(this.variantSelect, "Variant");
    this.hideVariant2();
    if (this.submodelField) this.submodelField.style.display = 'none';
  }

  resetAutomotiveState() {
    this.state.year = ""; this.state.autoMake = ""; this.state.autoModel = ""; this.state.trim = ""; this.state.engine = "";
    this.resetSelect(this.yearSelect, "Year", false); this.resetSelect(this.autoMakeSelect, "Make");
    this.resetSelect(this.autoModelSelect, "Model"); this.resetSelect(this.trimSelect, "Trim"); this.resetSelect(this.engineSelect, "Engine");
  }

  populateMakes() {
    const makes = this.unique(this.heavyDutyData.map(d => d.make));
    this.resetSelect(this.makeSelect, "Make", false);
    makes.forEach(m => { const opt = document.createElement("option"); opt.value = m; opt.textContent = m; this.makeSelect.appendChild(opt); });
  }

  // Populate the Model dropdown from the current make, optionally narrowed by type/submodel.
  // Called right after Make so Model is choosable without first picking Type.
  populateModelsFor(opts) {
    opts = opts || {};
    const models = this.unique(this.heavyDutyData.filter(d =>
      d.make === this.state.make &&
      (!opts.type || d.type === opts.type) &&
      (!opts.submodel || d.submodel === opts.submodel)
    ).map(d => d.model));
    this.resetSelect(this.modelSelect, "Model", false);
    models.forEach(m => { const opt = document.createElement("option"); opt.value = m; opt.textContent = m; this.modelSelect.appendChild(opt); });
  }

  // Show/populate the Sub-Model field for a given type (no-op/hide when the type has none).
  syncSubmodelField(type) {
    const submodels = this.unique(this.heavyDutyData.filter(d => d.make === this.state.make && d.type === type).map(d => d.submodel));
    if (submodels.length > 0) {
      if (this.submodelField) this.submodelField.style.display = 'block';
      this.resetSelect(this.submodelSelect, "Sub-Model", false);
      submodels.forEach(sm => { const opt = document.createElement("option"); opt.value = sm; opt.textContent = sm; this.submodelSelect.appendChild(opt); });
      return true;
    }
    if (this.submodelField) this.submodelField.style.display = 'none';
    return false;
  }

  onMake() {
    this.state.make = this.makeSelect.value || "";
    this.state.type = ""; this.state.submodel = ""; this.state.model = ""; this.state.variant = ""; this.state.variant2 = "";
    this.resetSelect(this.typeSelect, "Type"); this.resetSelect(this.submodelSelect, "Sub-Model");
    this.resetSelect(this.modelSelect, "Model"); this.resetSelect(this.variantSelect, "Variant");
    this.hideVariant2();
    if (this.submodelField) this.submodelField.style.display = 'none';
    if (!this.state.make) return;
    const types = this.unique(this.heavyDutyData.filter(d => d.make === this.state.make).map(d => d.type));
    this.resetSelect(this.typeSelect, "Type", false);
    types.forEach(t => { const opt = document.createElement("option"); opt.value = t; opt.textContent = t; this.typeSelect.appendChild(opt); });
    // Both Type and Model are now choosable: populate Model with every model for this make.
    this.populateModelsFor({});
  }

  onType() {
    this.state.type = this.typeSelect.value || "";
    this.state.submodel = ""; this.state.model = ""; this.state.variant = ""; this.state.variant2 = "";
    this.resetSelect(this.submodelSelect, "Sub-Model"); this.resetSelect(this.variantSelect, "Variant");
    this.hideVariant2();
    if (!this.state.make) { this.resetSelect(this.modelSelect, "Model"); return; }
    if (!this.state.type) {
      // Type cleared: restore the full model list for the make.
      if (this.submodelField) this.submodelField.style.display = 'none';
      this.populateModelsFor({});
      return;
    }
    // Sub-Model is an optional refinement; Model stays directly choosable, narrowed to the type.
    this.syncSubmodelField(this.state.type);
    this.populateModelsFor({ type: this.state.type });
  }

  onSubmodel() {
    this.state.submodel = this.submodelSelect.value || "";
    this.state.model = ""; this.state.variant = ""; this.state.variant2 = "";
    this.resetSelect(this.variantSelect, "Variant");
    this.hideVariant2();
    this.populateModelsFor({ type: this.state.type, submodel: this.state.submodel });
  }

  onModel() {
    this.state.model = this.modelSelect.value || ""; this.state.variant = ""; this.state.variant2 = "";
    this.resetSelect(this.variantSelect, "Variant");
    this.hideVariant2();
    if (!this.state.model) return;
    // If Type (and/or Sub-Model) weren't chosen, back-fill them from the selected model.
    let rows = this.heavyDutyData.filter(d => d.make === this.state.make && d.model === this.state.model
      && (!this.state.type || d.type === this.state.type)
      && (!this.state.submodel || d.submodel === this.state.submodel));
    if (!rows.length) {
      // A previously auto-filled type/submodel no longer fits this model: re-derive cleanly.
      this.state.type = ""; this.state.submodel = "";
      rows = this.heavyDutyData.filter(d => d.make === this.state.make && d.model === this.state.model);
    }
    if (rows.length) {
      const row = rows[0];
      if (!this.state.type && row.type) {
        this.state.type = row.type;
        if (this.typeSelect) { this.typeSelect.value = row.type; if (this.typeSelect._searchableUpdate) this.typeSelect._searchableUpdate(); }
        this.syncSubmodelField(row.type);
      }
      if (!this.state.submodel && row.submodel) {
        this.state.submodel = row.submodel;
        if (this.submodelSelect) { this.submodelSelect.value = row.submodel; if (this.submodelSelect._searchableUpdate) this.submodelSelect._searchableUpdate(); }
      }
    }
    let filteredData = this.heavyDutyData.filter(d => d.make === this.state.make && d.type === this.state.type && d.model === this.state.model);
    if (this.state.submodel) filteredData = filteredData.filter(d => d.submodel === this.state.submodel);
    const variants = this.unique(filteredData.map(d => d.variant));
    if (variants.length > 0) { this.resetSelect(this.variantSelect, "Variant", false); variants.forEach(v => { const opt = document.createElement("option"); opt.value = v; opt.textContent = v; this.variantSelect.appendChild(opt); }); }
    else { this.variantSelect.innerHTML = `<option value="">No Variants Available</option>`; this.variantSelect.disabled = true; }
  }

  onVariant() {
    this.state.variant = this.variantSelect.value || "";
    this.state.variant2 = "";
    if (!this.state.variant) { this.hideVariant2(); return; }
    let filtered = this.heavyDutyData.filter(d =>
      d.make === this.state.make && d.type === this.state.type &&
      d.model === this.state.model && d.variant === this.state.variant);
    if (this.state.submodel) filtered = filtered.filter(d => d.submodel === this.state.submodel);
    const variant2s = this.unique(filtered.map(d => d.variant2));
    if (variant2s.length > 0) {
      if (this.variant2Field) this.variant2Field.style.display = 'block';
      this.resetSelect(this.variant2Select, "Variant 2", false);
      variant2s.forEach(v => { const opt = document.createElement("option"); opt.value = v; opt.textContent = v; this.variant2Select.appendChild(opt); });
    } else {
      this.hideVariant2();
    }
  }

  onVariant2() { this.state.variant2 = this.variant2Select.value || ""; }

  hideVariant2() {
    this.state.variant2 = "";
    if (this.variant2Select) this.resetSelect(this.variant2Select, "Variant 2");
    if (this.variant2Field) this.variant2Field.style.display = 'none';
  }

  populateYears() {
    const data = this.getVehicleData();
    const years = this.unique(data.map(d => d.year)).sort((a, b) => b - a);
    this.resetSelect(this.yearSelect, "Year", false);
    years.forEach(y => { const opt = document.createElement("option"); opt.value = y; opt.textContent = y; this.yearSelect.appendChild(opt); });
  }

  onYear() {
    this.state.year = this.yearSelect.value || "";
    this.state.autoMake = ""; this.state.autoModel = ""; this.state.trim = ""; this.state.engine = "";
    this.resetSelect(this.autoMakeSelect, "Make"); this.resetSelect(this.autoModelSelect, "Model");
    this.resetSelect(this.trimSelect, "Trim"); this.resetSelect(this.engineSelect, "Engine");
    if (!this.state.year) return;
    const data = this.getVehicleData();
    const makes = this.unique(data.filter(d => d.year === this.state.year).map(d => d.make));
    this.resetSelect(this.autoMakeSelect, "Make", false);
    makes.forEach(m => { const opt = document.createElement("option"); opt.value = m; opt.textContent = m; this.autoMakeSelect.appendChild(opt); });
  }

  onAutoMake() {
    this.state.autoMake = this.autoMakeSelect.value || "";
    this.state.autoModel = ""; this.state.trim = ""; this.state.engine = "";
    this.resetSelect(this.autoModelSelect, "Model"); this.resetSelect(this.trimSelect, "Trim"); this.resetSelect(this.engineSelect, "Engine");
    if (!this.state.autoMake) return;
    const data = this.getVehicleData();
    const models = this.unique(data.filter(d => d.year === this.state.year && d.make === this.state.autoMake).map(d => d.model));
    this.resetSelect(this.autoModelSelect, "Model", false);
    models.forEach(m => { const opt = document.createElement("option"); opt.value = m; opt.textContent = m; this.autoModelSelect.appendChild(opt); });
  }

  onAutoModel() {
    this.state.autoModel = this.autoModelSelect.value || ""; this.state.trim = ""; this.state.engine = "";
    this.resetSelect(this.trimSelect, "Trim"); this.resetSelect(this.engineSelect, "Engine");
    if (!this.state.autoModel) return;
    const data = this.getVehicleData();
    const filtered = data.filter(d => d.year === this.state.year && d.make === this.state.autoMake && d.model === this.state.autoModel);
    const trims = this.unique(filtered.map(d => d.trim));
    const engines = this.unique(filtered.map(d => d.engine));
    if (trims.length > 0) { this.resetSelect(this.trimSelect, "Trim", false); trims.forEach(t => { const opt = document.createElement("option"); opt.value = t; opt.textContent = t; this.trimSelect.appendChild(opt); }); }
    else { this.trimSelect.innerHTML = `<option value="">No Trims Available</option>`; this.trimSelect.disabled = true; }
    if (engines.length > 0) { this.resetSelect(this.engineSelect, "Engine", false); engines.forEach(e => { const opt = document.createElement("option"); opt.value = e; opt.textContent = e; this.engineSelect.appendChild(opt); }); }
    else { this.engineSelect.innerHTML = `<option value="">No Engines Available</option>`; this.engineSelect.disabled = true; }
  }

  onTrim() {
    this.state.trim = this.trimSelect.value || ""; this.state.engine = "";
    this.resetSelect(this.engineSelect, "Engine");
    const data = this.getVehicleData();
    let filtered = data.filter(d => d.year === this.state.year && d.make === this.state.autoMake && d.model === this.state.autoModel);
    if (this.state.trim) filtered = filtered.filter(d => d.trim === this.state.trim);
    const engines = this.unique(filtered.map(d => d.engine));
    if (engines.length > 0) { this.resetSelect(this.engineSelect, "Engine", false); engines.forEach(e => { const opt = document.createElement("option"); opt.value = e; opt.textContent = e; this.engineSelect.appendChild(opt); }); }
    else { this.engineSelect.innerHTML = `<option value="">No Engines Available</option>`; this.engineSelect.disabled = true; }
  }

  onEngine() { this.state.engine = this.engineSelect.value || ""; }

  prefillFromState() {
    const saved = { ...this.state };
    const { category, make, type, submodel, model, variant, variant2, year, autoMake, autoModel, trim, engine } = saved;
    this.categorySelect.value = category || "Heavy-Duty Machinery"; this.onCategory();
    if (category === 'Heavy-Duty Machinery' || (!category && !year)) {
      if (make) { this.makeSelect.value = make; this.onMake(); }
      if (type) { this.typeSelect.value = type; this.onType(); }
      if (submodel) { this.submodelSelect.value = submodel; this.onSubmodel(); }
      if (model) { this.modelSelect.value = model; this.onModel(); }
      if (variant) { this.variantSelect.value = variant; this.onVariant(); }
      if (variant2) { this.variant2Select.value = variant2; this.onVariant2(); }
    } else {
      if (year) { this.yearSelect.value = year; this.onYear(); }
      if (autoMake) { this.autoMakeSelect.value = autoMake; this.onAutoMake(); }
      if (autoModel) { this.autoModelSelect.value = autoModel; this.onAutoModel(); }
      if (trim) { this.trimSelect.value = trim; this.onTrim(); }
      if (engine) { this.engineSelect.value = engine; this.onEngine(); }
    }
    // Preserve the intended selection even if some dropdowns had no matching option (e.g. a make the
    // live-SKU filter dropped, or a kit-only machine not in the CSV dropdowns). onCategory/onMake reset
    // the fields to "" as they run; without restoring here the machine silently vanishes from state —
    // which is why equipment added from the sidebar was saving with blank Make/Type/Model.
    this.state = { ...this.state, ...saved };
  }

  applySelection() {
    const currentParams = new URLSearchParams(window.location.search);
    const currentView = currentParams.get("view");
    const params = new URLSearchParams();
    const { category, make, type, submodel, model, variant, variant2, year, autoMake, autoModel, trim, engine } = this.state;
    if (category) params.set("category", category);
    if (category === 'Heavy-Duty Machinery') {
      if (make) params.set("make", make); if (type) params.set("type", type);
      if (submodel) params.set("submodel", submodel); if (model) params.set("model", model);
      if (variant) params.set("variant", variant);
      if (variant2) params.set("variant2", variant2);
    } else {
      if (year) params.set("year", year); if (autoMake) params.set("make", autoMake);
      if (autoModel) params.set("model", autoModel); if (trim) params.set("trim", trim);
      if (engine) params.set("engine", engine);
    }
    if (currentView) params.set("view", currentView);
    window.location.href = `/collections/all?${params.toString()}`;
  }

  openAddEquipmentModal() {
    const { category, make, type, submodel, model, variant, variant2, year, autoMake, autoModel, trim, engine } = this.state;
    
    // Build display text
    let displayText = '';
    let actualCategory = category || 'Heavy-Duty Machinery';
    if (actualCategory === 'Heavy-Duty Machinery' || (!category && (make || type || model))) {
      displayText = [make, type, model, variant].filter(Boolean).join(' ');
      actualCategory = 'Heavy-Duty Machinery';
    } else {
      displayText = [year, autoMake, autoModel, trim].filter(Boolean).join(' ');
    }
    
    // Remove existing modal if any
    const existing = document.getElementById('filterEquipmentModal');
    if (existing) existing.remove();
    
    // Build modal HTML
    const modalHtml = `
      <div class="equipment-modal-overlay" id="filterEquipmentModal">
        <div class="equipment-modal" style="max-width:450px;">
          <div class="equipment-modal-header">
            <h2 style="margin:0;font-size:18px;">Add to My Equipment</h2>
            <button type="button" class="equipment-modal-close" id="closeFilterEquipmentModal" style="background:none;border:none;font-size:24px;cursor:pointer;">&times;</button>
          </div>
          <div class="equipment-modal-body" style="padding:20px;">
            <div class="filter-equipment-preview" style="background:#f8f9fa;border:1px solid #e9ecef;border-radius:8px;padding:16px;margin-bottom:20px;text-align:center;">
              <div style="font-size:12px;text-transform:uppercase;color:#6b7280;margin-bottom:4px;letter-spacing:0.5px;">${this.escapeHtml(actualCategory)}</div>
              <div style="font-size:18px;font-weight:600;color:#1f2937;">${this.escapeHtml(displayText)}</div>
            </div>
            <div class="form-group" style="margin-bottom:15px;">
              <label for="filterEquipmentSku" style="display:block;font-weight:600;margin-bottom:5px;">Your SKU/ID *</label>
              <input type="text" id="filterEquipmentSku" placeholder="e.g., TRACTOR-01, TRUCK-A, MY-CAR" style="width:100%;padding:10px;border:1px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;">
              <span style="font-size:12px;color:#6b7280;margin-top:4px;display:block;">A unique identifier you'll recognize</span>
            </div>
            <div class="form-group" style="margin-bottom:15px;">
              <label for="filterEquipmentSerial" style="display:block;font-weight:600;margin-bottom:5px;">Serial # (Optional)</label>
              <input type="text" id="filterEquipmentSerial" placeholder="Equipment serial number" style="width:100%;padding:10px;border:1px solid #ddd;border-radius:4px;font-size:14px;box-sizing:border-box;">
            </div>
            <div class="form-group" style="margin-bottom:15px;">
              <label style="display:flex;align-items:center;gap:8px;cursor:pointer;">
                <input type="checkbox" id="filterEquipmentFavorite" style="width:16px;height:16px;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#fbbf24" stroke="#fbbf24" stroke-width="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
                Add to Quick Access Favorites
              </label>
              <span id="filterEquipmentFavoriteHint" style="font-size:12px;color:#6b7280;margin-top:4px;display:block;margin-left:24px;"></span>
            </div>
          </div>
          <div class="equipment-modal-footer" style="padding:15px 20px;border-top:1px solid #e5e5e5;display:flex;justify-content:flex-end;gap:10px;">
            <button type="button" id="cancelFilterEquipmentBtn" style="padding:10px 20px;border:1px solid #ddd;background:#fff;border-radius:4px;cursor:pointer;">Cancel</button>
            <button type="button" id="saveFilterEquipmentBtn" style="padding:10px 20px;border:none;background:#F7B910;color:#000;font-weight:600;border-radius:4px;cursor:pointer;">Save Equipment</button>
          </div>
        </div>
      </div>`;
    
    document.body.insertAdjacentHTML('beforeend', modalHtml);
    
    // Add modal styles if not present
    if (!document.getElementById('equipment-modal-styles')) {
      const styles = document.createElement('style');
      styles.id = 'equipment-modal-styles';
      styles.textContent = `
        .equipment-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
        }
        .equipment-modal {
          background: #fff;
          border-radius: 8px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
        }
        .equipment-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 20px;
          border-bottom: 1px solid #e5e5e5;
        }
        .equipment-toast {
          position: fixed;
          bottom: 20px;
          right: 20px;
          padding: 12px 20px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          gap: 10px;
          z-index: 10001;
          animation: slideIn 0.3s ease;
          transition: opacity 0.3s ease;
        }
        .equipment-toast.success { background: #10b981; color: #fff; }
        .equipment-toast.error { background: #ef4444; color: #fff; }
        .equipment-toast.info { background: #3b82f6; color: #fff; }
        @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
      `;
      document.head.appendChild(styles);
    }
    
    const modal = document.getElementById('filterEquipmentModal');
    const closeBtn = document.getElementById('closeFilterEquipmentModal');
    const cancelBtn = document.getElementById('cancelFilterEquipmentBtn');
    const saveBtn = document.getElementById('saveFilterEquipmentBtn');
    const skuInput = document.getElementById('filterEquipmentSku');
    
    // Update favorite hint
    this.updateFavoriteHint();
    
    // Focus SKU input
    setTimeout(() => skuInput.focus(), 100);
    
    // Close handlers
    const closeModal = () => modal.remove();
    closeBtn.addEventListener('click', closeModal);
    cancelBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    
    // Save handler
    saveBtn.addEventListener('click', () => this.saveFilterToEquipment(closeModal));
    
    // Enter key to save
    skuInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.saveFilterToEquipment(closeModal);
      }
    });
  }
  
  updateFavoriteHint() {
    const hint = document.getElementById('filterEquipmentFavoriteHint');
    const checkbox = document.getElementById('filterEquipmentFavorite');
    if (!hint) return;
    
    let currentFavorites = 0;
    try {
      const dataEl = document.getElementById('equipment-initial-data');
      if (dataEl) {
        const data = JSON.parse(dataEl.textContent);
        const machines = data.machines || data || [];
        currentFavorites = machines.filter(m => m.favorite).length;
      }
    } catch(e) {}
    
    const remaining = 4 - currentFavorites;
    if (remaining <= 0) {
      hint.textContent = 'Maximum 4 favorites reached.';
      if (checkbox) checkbox.disabled = true;
    } else {
      hint.textContent = remaining + ' slot' + (remaining !== 1 ? 's' : '') + ' available';
    }
  }
  
  saveFilterToEquipment(closeModal) {
    // Prefer the live selection (this.state); if it somehow has no machine, fall back to the URL. Both
    // are now reliable (prefill no longer wipes state), but this keeps the save robust either way.
    let src = this.state;
    if (!(src.make || src.type || src.model || src.year)) src = this.loadStateFromUrl() || this.state;
    const { category, make, type, submodel, model, variant, variant2, year, autoMake, autoModel, trim, engine } = src;
    const skuInput = document.getElementById('filterEquipmentSku');
    const serialInput = document.getElementById('filterEquipmentSerial');
    const favoriteCheckbox = document.getElementById('filterEquipmentFavorite');
    const saveBtn = document.getElementById('saveFilterEquipmentBtn');
    
    const sku = skuInput.value.trim();
    const serial = serialInput ? serialInput.value.trim() : '';
    const favorite = favoriteCheckbox ? favoriteCheckbox.checked : false;
    
    if (!sku) {
      this.showEquipmentToast('Please enter a SKU/ID', 'error');
      skuInput.focus();
      return;
    }

    // Don't save an empty machine (blank Make/Type/Model) — that's the blank-row symptom.
    if (!(make || type || model || year || autoMake || autoModel)) {
      this.showEquipmentToast('Please select a machine first', 'error');
      return;
    }
    
    // Build machine object
    let actualCategory = category || 'Heavy-Duty Machinery';
    if (!category && year) actualCategory = 'Automotive';
    
    const machine = {
      id: 'eq_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      name: sku,
      category: actualCategory,
      make: actualCategory === 'Heavy-Duty Machinery' ? make : autoMake,
      serial: serial,
      favorite: favorite,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    if (actualCategory === 'Heavy-Duty Machinery') {
      machine.type = type;
      machine.submodel = submodel;
      machine.model = model;
      machine.variant = variant;
      machine.variant2 = variant2;
    } else {
      machine.year = year;
      machine.model = autoModel;
      machine.trim = trim;
      machine.engine = engine;
    }
    
    // Get existing equipment data
    let equipmentData = { machines: [] };
    let hadExistingData = false;
    try {
      const dataEl = document.getElementById('equipment-initial-data');
      if (dataEl) {
        const data = JSON.parse(dataEl.textContent);
        if (Array.isArray(data)) {
          equipmentData = { machines: data };
          hadExistingData = true;
        } else if (data && Array.isArray(data.machines)) {
          equipmentData = data;
          hadExistingData = true;
        }
      }
    } catch(e) {
      console.error('Error parsing equipment data:', e);
    }
    
    // Check for duplicate SKU
    const duplicateExists = equipmentData.machines.some(m => 
      m.name && m.name.toLowerCase() === sku.toLowerCase()
    );
    
    if (duplicateExists) {
      this.showEquipmentToast('Equipment with this SKU/ID already exists', 'error');
      skuInput.focus();
      return;
    }
    
    // Check favorite limit
    if (favorite) {
      const currentFavorites = equipmentData.machines.filter(m => m.favorite).length;
      if (currentFavorites >= 4) {
        this.showEquipmentToast('Maximum 4 favorites allowed', 'error');
        return;
      }
    }
    
    // Add machine
    equipmentData.machines.push(machine);
    
    // Save to server
    saveBtn.disabled = true;
    saveBtn.textContent = 'Saving...';
    
    const endpoint = window.equipmentConfig?.apiEndpoint;
    const fallbackEndpoint = window.equipmentConfig?.fallbackEndpoint;
    const customerId = window.equipmentConfig?.customerId;
    
    if (!endpoint || !customerId) {
      // No API configured - store in localStorage as fallback
      try {
        localStorage.setItem('pendingEquipment', JSON.stringify(machine));
      } catch(e) {}
      closeModal();
      this.showEquipmentToast('Equipment saved! Visit My Equipment page to sync.', 'success');
      return;
    }
    
    // Post the SAME shape the My Equipment page uses: the full equipment list. The server replaces
    // the customer metafield with equipmentData; it does NOT understand an {action:'add'} delta, which
    // is why machines added from the sidebar were landing blank / not at all.
    // SAFETY: only send the full list when we actually read the existing one (equipment-initial-data
    // was present on this page). If it wasn't, sending our list — which would contain only the new
    // machine — could wipe the customer's other equipment, so fall back to the add-delta instead.
    const savePayload = hadExistingData
      ? { customerId: customerId, equipmentData: equipmentData }
      : { customerId: customerId, action: 'add', equipment: machine };
    
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(savePayload)
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed');
      return response.json();
    })
    .then(() => {
      closeModal();
      this.showEquipmentToast('Equipment added successfully!', 'success');
      window.dispatchEvent(new CustomEvent('equipment-updated'));
    })
    .catch(error => {
      console.error('Primary save failed, trying fallback:', error);
      // Try fallback endpoint
      if (fallbackEndpoint) {
        fetch(fallbackEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(savePayload)
        })
        .then(response => {
          if (!response.ok) throw new Error('Fallback failed');
          return response.json();
        })
        .then(() => {
          closeModal();
          this.showEquipmentToast('Equipment added successfully!', 'success');
          window.dispatchEvent(new CustomEvent('equipment-updated'));
        })
        .catch(fallbackError => {
          console.error('Fallback save failed:', fallbackError);
          this.showEquipmentToast('Error saving. Please try again.', 'error');
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save Equipment';
        });
      } else {
        this.showEquipmentToast('Error saving. Please try again.', 'error');
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save Equipment';
      }
    });
  }
  
  showEquipmentToast(message, type) {
    const existing = document.querySelector('.equipment-toast');
    if (existing) existing.remove();
    
    const toast = document.createElement('div');
    toast.className = 'equipment-toast ' + type;
    
    let icon = '';
    if (type === 'success') {
      icon = '<polyline points="20 6 9 17 4 12"></polyline>';
    } else if (type === 'error') {
      icon = '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>';
    } else {
      icon = '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>';
    }
    
    toast.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' + icon + '</svg>' + message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
  
  escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  clearSelection() {
    this.state = { category: "Heavy-Duty Machinery", make: "", type: "", submodel: "", model: "", variant: "", year: "", autoMake: "", autoModel: "", trim: "", engine: "" };
    this.categorySelect.value = "Heavy-Duty Machinery"; this.onCategory(); this.updateBanner();
    const currentParams = new URLSearchParams(window.location.search);
    const currentView = currentParams.get("view");
    let url = "/collections/all"; if (currentView) url += `?view=${currentView}`;
    window.location.href = url;
  }
}

customElements.define("fitment-sidebar", FitmentSidebar);